// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"79da49c2","743":"20530d55","917":"fe3402ef"}[chunkId] + ".chunk.js";
};